exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-card {\n  max-width: 500px;\n  margin: 24px auto;\n}\n\n.input-full-width {\n  width: 100%;\n}\n\n.form-button-container {\n  text-align: right;\n}\n\n.login-error {\n  color: #C62828;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = 208
// module chunks = 1